import {Link} from "react-router-dom";
import {address, logo_image, products} from "../data/data";
import {useTranslation} from "react-i18next";

const navigateToTop = () => {
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
}

function Footer() {
    const { t } = useTranslation();
    return (
        <div className="footer flex flex-col justify-center bg-background-color/50 px-20 max-md:px-8">
            <div className="flex max-lg:flex-col-reverse flex-row md:flex-row py-12 justify-between">
                <Address/>
                <div className="pt-4 flex flex-col gap-12">
                    <Product/>
                    <Link to="/about" onClick={navigateToTop}>
                        <h1>{t("navigation_menu_about")}</h1>
                    </Link>
                </div>
                <Logo className="py-2 md:hidden"/>
            </div>
            <Copyright/>
        </div>
    )
}

export default Footer;

function Logo(props) {
    const {t} = useTranslation();
    return (<img src={logo_image[t('logo')]} alt="Logo" className={`w-36 ${props.className}`}/>)
}

function Address() {
    const {t} = useTranslation();
    return (
        <div className="flex flex-col items-start w-full max-w-96 gap-4">
            <Logo className="py-2 max-md:hidden" />
            <h1 className="mt-12 md:hidden">{t("navigation_menu_contact")}</h1>
            <div className="text-secondary-color text-xl font-bold my-2 flex flex-row">
                <div className="bg-primary rounded-full aspect-square w-6 h-6 flex items-center justify-center">
                    <svg width="14" height="14" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M22.2799 4.68281L19.4272 1.83281C19.079 1.4846 18.6129 1.28906 18.1201 1.28906C17.6272 1.28906 17.1611 1.48192 16.8129 1.83281L13.7406 4.89978C13.3924 5.24799 13.1968 5.71674 13.1968 6.2096C13.1968 6.70513 13.3897 7.16853 13.7406 7.51942L16.1406 9.9221C15.5939 11.196 14.8083 12.3534 13.8263 13.3319C12.8433 14.3203 11.6942 15.0998 10.4192 15.6516L8.01917 13.2489C7.67096 12.9007 7.20488 12.7051 6.71203 12.7051C6.46893 12.7042 6.22809 12.7519 6.00364 12.8452C5.77918 12.9386 5.57562 13.0758 5.40488 13.2489L2.32988 16.3158C1.98167 16.6641 1.78613 17.1328 1.78613 17.6257C1.78613 18.1212 1.97899 18.5846 2.32988 18.9355L5.17988 21.7855C5.77453 22.3801 6.59417 22.7203 7.43524 22.7203C7.60935 22.7203 7.7781 22.7069 7.94953 22.6775C11.496 22.0935 15.0156 20.2051 17.8576 17.3659C20.6968 14.5212 22.5826 11.0016 23.1719 7.45246C23.3406 6.44531 23.0031 5.40871 22.2799 4.68281ZM21.2727 7.13371C20.7504 10.2917 19.0522 13.4417 16.4942 15.9998C13.9361 18.5578 10.7888 20.256 7.63078 20.7783C7.23435 20.8453 6.8272 20.7114 6.53792 20.4248L3.73881 17.6257L6.70667 14.6551L9.9156 17.8694L9.9397 17.8935L10.5183 17.6792C12.2725 17.0343 13.8656 16.0155 15.187 14.6937C16.5084 13.3718 17.5266 11.7784 18.171 10.0239L18.3852 9.44531L15.1495 6.21228L18.1174 3.24174L20.9165 6.04085C21.2058 6.33013 21.3397 6.73728 21.2727 7.13371Z"
                            fill="#fff"/>
                    </svg>
                </div>
                <div className="ml-2">+6663-190-7455</div>
            </div>
            {address.map((item, index) => (
                <div className="flex flex-col gap-2" key={index}>
                    <h1>{t(item.name)}</h1>
                    <p>{t(item.description)}</p>
                </div>
            ))}
        </div>
    )
}

function Product() {
    const {t} = useTranslation();
    return (
        <div>
            <Link to="/product/cotton" onClick={navigateToTop}>
                <h1>{t("footer_product_title")}</h1>
            </Link>
            <div className="flex flex-wrap gap-12 mt-4">
                {products.map((product, index) => (
                    <div key={product.type} className="flex flex-col min-w-80 gap-4">
                        <Link to={`/product/${product.type}`} onClick={navigateToTop}>
                            <h2 className="py-2 border-b border-black">{t(product.category)}</h2>
                        </Link>
                        <div className="flex flex-row gap-2 justify-between pr-8">
                            {product.groups.map((group, index) => (
                                <ProductGroup key={index} name={group.name} type={product.type} items={group.items}/>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

const ProductGroup = ({name, type, items}) => {
    const {t} = useTranslation();
    return (
        <div className="flex flex-col">
            <p className="mb-2">{t(name)}</p>
            <div className="ml-4 flex flex-col gap-0.5">
                {items.map((item) => (
                    <Link key={item.id} to={`/product/${type}/${item.id}`} onClick={navigateToTop}>
                        <p className="text-grey">{t(item.title)}</p>
                    </Link>
                ))}
            </div>
        </div>
    )
}

function Copyright() {
    return (
        <div className="flex border-t border-black pt-3 pb-8 text-xs justify-end mb-2">
            <p>© สงวนลิขสิทธิ์ 2567 บริษัท สยามสำลี จำกัด</p>
        </div>
    )
}
